import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/website/arr.png'


const _hoisted_1 = { class: "banner" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "text"
}
const _hoisted_4 = { class: "banan" }
const _hoisted_5 = { class: "mainbox clearfix" }
const _hoisted_6 = { class: "items clearfix" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "coor"
}
const _hoisted_12 = { class: "mainbox items" }
const _hoisted_13 = {
  key: 0,
  class: "arr"
}

import { reactive, onMounted, watch, ref } from "vue";
import Nav from "@/components/nav/Index.vue";

import Item from "./Item.vue";
import { getAllSolutionType } from "@/api/backstage";
import { getAllCooperative } from "@/api/index";


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
  isMobile: Boolean,
},
  setup(__props) {

const props = __props;

const mb = ref("");
watch(
  () => props.isMobile,
  (newv, oldv) => {
    props.isMobile ? (mb.value = true) : (mb.value = false);
  }
);

const datas: any = reactive({
  banner: "",
  filurl: localStorage.getItem("fileUrel"),
  items: "",
  cooer: [],
  hot: [],
});

const getData = () => {
  getAllSolutionType().then((res: any) => {
    for (let i = 0; i < res.data[0].solutions.length; i += 2) {
      datas.hot.push(res.data[0].solutions.slice(i, i + 2));
    }
    res.data.shift();
    datas.items = res.data;
    for (const item of datas.items) {
      if (item.fileName) item.img = localStorage.getItem("fileUrel") + item.fileName;
    }
  });
};

const getCooper = () => {
  getAllCooperative().then((res: any) => {
    datas.cooer = res?.data;
  });
};

const getBanner = (banner) => {
  datas.banner = banner;
};

onMounted(() => {
  getData();
  getCooper();
  mb.value = props.isMobile;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(mb.value ? 'Mobile' : 'pc')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Nav, {
        isMobile: mb.value,
        onGetBanner: getBanner
      }, null, 8, ["isMobile"]),
      (datas.banner.length == 1)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: datas.filurl + datas.banner[0].fileName,
            alt: ""
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      (datas.banner.length == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(datas.banner[0].title), 1),
            _createElementVNode("p", null, _toDisplayString(datas.banner[0].description), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[0] || (_cache[0] = _createElementVNode("h2", null, "热门解决方案", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.hot, (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createVNode(Item, {
            item: item,
            isMobile: mb.value,
            index: index
          }, null, 8, ["item", "isMobile", "index"])
        ]))
      }), 128)),
      _cache[1] || (_cache[1] = _createElementVNode("h2", null, "其他解决方案", -1)),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.items, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["item", { big: index % 3 == 0 }]),
            key: index
          }, [
            _createElementVNode("img", {
              src: item.img,
              alt: ""
            }, null, 8, _hoisted_7),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h3", null, _toDisplayString(item.title), 1),
              (!mb.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(item.description), 1))
                : _createCommentVNode("", true)
            ])
          ], 2))
        }), 128))
      ]),
      (!mb.value)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_10, "合作流程"))
        : _createCommentVNode("", true)
    ]),
    (!mb.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.cooer, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "group",
                key: index
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["item", index % 2 == 0 ? 'bg1' : 'bg2'])
                }, _toDisplayString(item.title), 3),
                (index != datas.cooer.length - 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("img", {
                        src: _imports_0,
                        alt: ""
                      }, null, -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})